import { Injectable, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';

import { Auth } from '@angular/fire/auth';
import { Observable } from 'rxjs';

import { AppState } from '../app.state';
import {
    LoadConversationsAction, 
    LoadConversationsFailedAction, 
    LoadConversationsSucceededAction, 
    CreateNewConversationAction
} from './conversations.actions';


@Injectable()
export class ConversationsStoreDispatcher {
    constructor(private store: Store<AppState>) { }

    public createNewConversation(userID) {
        this.store.dispatch(new CreateNewConversationAction(userID));
    }

    public loadConversations() {
        this.store.dispatch(new LoadConversationsAction());
    }
}
